import type { Dictionnaire } from '../type';

export const composants: Dictionnaire['composants'] = {
  champ: {
    masquer: '隐藏密码',
    afficher: '显示密码',
    effacer: '清除搜索',
  },
  badge: {
    officiel: 'Sirocco 官方账号',
    verifie: '已认证账号',
  },
  bulleAppel: {
    revenir: (nom: string) => `返回与 ${nom} 的通话`,
  },
  etat: {
    annule: '已取消：参与人数不足',
    confirme: '已确认',
    spontanee: '临时活动',
    enLigne: '线上',
    seuil: (n: number) => `（至少 ${n} 人）`,
  },
  vocal: {
    pause: '暂停',
    ecouter: '播放语音消息',
    apercu: (duree: string) => `语音消息，${duree}`,
  },
  onglets: {
    messages: '消息',
    evenements: '活动',
    feed: '动态',
    lieux: '地点',
    profil: '我的',
    annuaire: '名录',
  },
  barre: {
    navigation: '主导航',
    aRegarder: (onglet: string, n: number) => `${onglet} · ${n} 条待查看`,
  },
  photo: {
    pasOuverte: '无法打开这张图片',
    pasPreparee: '无法处理这张照片',
    recadrer: '裁剪照片',
    annuler: '取消',
    choisir: '选择',
  },
  fichier: {
    pasAjoute: '无法添加这个文件',
  },
  scanner: {
    sansCamera: 'Sirocco 无法使用相机。你可以手动勾选出席。',
  },
  partage: {
    pasParti: '分享没有成功。',
    lienCopie: '链接已复制。',
    impossible: '此浏览器不支持分享。',
    copieImpossible: '此浏览器不支持复制。',
    titre: '分享',
    chercher: '搜索好友或群组',
    unInstant: '请稍候…',
    sansCible: '添加好友或创建群组，就能在 Sirocco 内直接分享。',
    aucun: '没有匹配的名字。',
    envoi: '发送中…',
    ailleurs: '分享到其他应用',
    copier: '复制链接',
    envoyeA: (nom: string) => `已发送给 ${nom}。`,
  },
  image: {
    pasUneImage: '这个文件不是图片',
    navigateur: '你的浏览器无法处理这张图片',
    tropLourde: '这张图片太大了，请换一张',
    pasOuverte: '无法打开这张图片',
  },
  video: {
    tropLourde: (mo: number) => `这个视频太大了：${mo} MB，上限为 25 MB。请用普通画质拍摄，不要用 4K。`,
    tropLongue: (secondes: number) => `最长十五秒。这个视频有 ${secondes} 秒。`,
  },
  voix: {
    appareil: '你的设备无法录制语音消息',
    micro: 'Sirocco 无法使用麦克风。请在设置中允许。',
    interrompu: '录音已中断',
    tropCourt: '太短了。请多按住一会儿。',
    tropLong: '语音消息太长，无法发送',
    illisible: '录音无法读取',
  },
  itineraire: {
    plans: '地图',
  },
  billet: {
    monBillet: '我的票',
  },
  emojis: {
    smileys: '笑脸',
    gestes: '手势',
    coeurs: '爱心',
    animaux: '动物',
    nourriture: '食物',
    sports: '运动',
    voyages: '旅行',
    objets: '物品',
    symboles: '符号',
  },
};
